<template>
  <div>
    <div class="page-wrapper profile-summary" style="padding-top: 0px;">
      <div class="container">
        <div class="top-wrap">
          <div class="page-heading">
            <h1 class="page-title">{{ atheleteData.athletename }}</h1>
            <div class="extra-view">
              <router-link
                :to="`/${profileId}/athletes/profile_views`"
                v-if="!public && ProfileData.profileType !== 'Basic'"
              >
                <a-tooltip>
                  <template slot="title"
                    >Click to know who viewed your profile.</template
                  >
                  <a-button type="primary" icon="usergroup-add"
                    >Profile Views- {{ atheleteData.views }}</a-button
                  >
                </a-tooltip>
              </router-link>
              <a-tooltip v-else-if="!public">
                <template slot="title"
                  >Upgrade Profile to access the view list.</template
                >
                <a-button type="primary" class="disable" icon="usergroup-add"
                  >Profile Views- {{ atheleteData.views }}</a-button
                >
              </a-tooltip>
              <div
                class="fav-click"
                @click="changeFav"
                :class="{ isfav: checkedFavourite.isFav }"
                v-if="public && profileType !== 'athlete'"
              >
                <a-icon type="heart" class="outline" theme="outlined" />
                <a-icon type="heart" class="fill" theme="filled" />
              </div>
            </div>
          </div>
          <a-alert
            message='Since your profile has been downgraded to Basic, Coaches will have a limited view of your profile ( Please click the Public View tab to preview your profile ). Upgrade options are located on the "Profiles List" tab.'
            type="warning"
            show-icon
            closable
            @close="onClose"
            v-if="ProfileData.profileType === 'Basic' && !public"
          />
        </div>
        <!-- content -->
        <div class="content">
          <Sliders
            :slider-images="
              atheleteData.images.map(item => generateImageUrl(item))
            "
            :logo-image="generateImageUrl(atheleteData.profileImage)"
            :social="socialList"
          />
          <div class="tab-section">
            <div v-if="playerIsDeactivated" class="custom-text">
              <p class="chat-connect-info" v-if="athlete.contactIsIgnored">
                You have ignored this user. Go to your ignored list and chat
                with this user.
              </p>
              <p class="chat-connect-info" v-else-if="athlete.isContactSaved">
                You have saved this user. Go to your saved list and chat with
                this user.
              </p>
              <p class="chat-connect-info" v-else>
                You have blocked this user. Go to your chat screen and unblock
                this user first.
              </p>
            </div>
            <div
              class="custom-button"
              @click="connectPlayer"
              v-else-if="userType !== 'athlete' && userHasNotBlockedGroup"
            >
              {{ atheleteData.isConnected ? "Message Player" : "Connect" }}
            </div>
            <div
              v-else-if="userType !== 'athlete'"
              class="player-unavailable"
            >
              This player is not available for connection.
            </div>
            <a-tabs
              class="show-tabs"
              default-active-key="1"
              tab-position="left"
            >
              <a-tab-pane key="1" tab="Player Details">
                <a-row :gutter="24">
                  <a-col :lg="12">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Basic information</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">Age:</th>
                              <td>
                                {{
                                  getAthleteAge(
                                    `${atheleteData.birthYear}-${atheleteData.birthMonth}-${atheleteData.birthDay}`
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Height/ Weight</th>
                              <td>
                                {{
                                  `${atheleteData.heightInFeet}'${atheleteData.heightInInch} / ${atheleteData.weight} lbs`
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">City:</th>
                              <td>{{ atheleteData.city }}</td>
                            </tr>
                            <tr>
                              <th scope="row">State:</th>
                              <td>
                                <span
                                  class="focused"
                                  v-if="atheleteData.state === 'International'"
                                  >{{ atheleteData.state }}</span
                                >
                                <span v-else>{{ atheleteData.state }}</span>
                              </td>
                            </tr>
                            <tr v-if="atheleteData.state === 'International'">
                              <th scope="row">Country:</th>
                              <td>
                                {{
                                  atheleteData.country &&
                                    atheleteData.country.name
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Committed to College:</th>
                              <td>
                                {{ atheleteData.committed ? "Yes" : "no" }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Grad Year:</th>
                              <td>{{ atheleteData.graduationYear }}</td>
                            </tr>
                            <tr v-if="atheleteData.remainingYears">
                              <th scope="row">Years Remaining to Play :</th>
                              <td>{{ atheleteData.remainingYears }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                  <a-col :lg="12">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Player Details</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">Playing Since:</th>
                              <td>{{ atheleteData.playingSince }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Preferred Position(s)</th>
                              <td>
                                {{
                                  atheleteData.position
                                    .map(item => item.name)
                                    .join(", ")
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Throwing Hand:</th>
                              <td>
                                {{
                                  atheleteData.throwingHand != null
                                    ? atheleteData.throwingHand
                                    : ""
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Batting Hand:</th>
                              <td>
                                {{
                                  atheleteData.battingHand != null
                                    ? atheleteData.battingHand
                                    : ""
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Batting Average:</th>
                              <td>{{ atheleteData.battingAverage }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Home to 1st Time:</th>
                              <td>{{ atheleteData.firstToHomeTime }} secs</td>
                            </tr>
                            <tr>
                              <th scope="row">2nd to Home Time:</th>
                              <td>{{ atheleteData.secondToHomeTime }} secs</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Academic Information">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Academic Information</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">Highschool :</th>
                              <td>{{ atheleteData.highSchool }}</td>
                            </tr>
                            <tr>
                              <th scope="row">ACT Scale Score :</th>
                              <td>{{ atheleteData.actScaleScore }}</td>
                            </tr>
                            <tr>
                              <th scope="row">SAT Score :</th>
                              <td>{{ atheleteData.satScore }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Likely Majors :</th>
                              <td>
                                {{
                                  atheleteData.majors &&
                                    atheleteData.majors.join(", ")
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">GPA :</th>
                              <td>{{ atheleteData.gpa }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="3" tab="Player Bio">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Player Bio</h2>
                      </div>
                      <div class="box-body">
                        <span class="bio pre-line">{{ athlete.bio }}</span>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </div>
          <!-- /.content -->
        </div>
        <!-- /.page-wrapper -->
      </div>
      <!-- /.container -->
      <!-- section popular-categories -->
      <section class="popular-categories" v-if="!public">
        <div class="container">
          <div class="main-heading text-center">
            <h1>Teams Played</h1>
          </div>
          <div class="teams-played-wrap">
            <div v-if="_.isEmpty(atheleteData.teamPlayedData)">
              <p class="text-center">No Data Available !</p>
            </div>
            <slick ref="slick" :options="slickOptions" v-else>
              <div
                class="item-slider"
                style="color:black;"
                v-for="v in atheleteData.teamPlayedData"
                :key="v._id"
              >
                <div class="item-holder">
                  <figure>
                    <h3>{{ v.name }}</h3>
                    <ul>
                      <li>
                        Team Name:
                        <span>{{ v.name }}</span>
                      </li>
                      <li>
                        Level:
                        <span>{{ v.level }}</span>
                      </li>
                      <li>
                        Positions:
                        <span class="position">
                          <span v-for="pos in v.position" :key="pos._id">{{
                            pos.name
                          }}</span>
                        </span>
                      </li>
                      <li>
                        Coach Name:
                        <span>{{ v.coachName }}</span>
                      </li>
                      <li>
                        Coach Phone:
                        <span>{{ v.coachPhone }}</span>
                      </li>
                      <li>
                        Coach Email:
                        <span>{{ v.coachEmail }}</span>
                      </li>
                    </ul>
                  </figure>
                </div>
              </div>
            </slick>
          </div>
        </div>
      </section>
      <!-- /.section /.popular-categories -->
      <Videos
        :videoData="[...athleteVideos].splice(0, 3)"
        :public="public"
        @view-all="changeListingRoute('videos')"
      ></Videos>
      <!-- Sections  latest-video-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Athlete } from "@/models";
import moment from "moment";
import Sliders from "../../../../commonprofile/slider";
import Videos from "../../../../commonprofile/video";
import Slick from "vue-slick";

const ATHLETE_STORE_KEY = "athleteStore";
const STORE_KEY = "playerStore";
const CHAT_STORE_KEY = "chatStore";
const FAVOURITE_STORE_KEY = "favouriteStore";

const SLICK_OPTIONS = {
  arrows: false,
  dots: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};

export default {
  name: "ProfileSummary",
  components: {
    Sliders,
    Videos,
    Slick
  },
  props: {
    id: {
      type: String,
      required: true
    },
    public: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      slickOptions: SLICK_OPTIONS,
      atheleteData: new Athlete({}),
      socialList: {}
    };
  },
  created() {
    this.dispatcher();
  },
  computed: {
    userHasNotBlockedGroup() {
      return (
        this.athlete.blockedGroup &&
        !this.athlete.blockedGroup.includes(Athlete.userType())
      );
    },
    playerIsDeactivated() {
      return (
        (this.athlete.isConnected && this.athlete.contactIsIgnored) ||
        (this.athlete.isConnected && this.athlete.contactIsBlocked) ||
        (this.athlete.isConnected && this.athlete.isContactSaved)
      );
    },
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
      athleteVideos: `${ATHLETE_STORE_KEY}/athleteVideos`,
      athleteEvents: `${ATHLETE_STORE_KEY}/athleteEvents`,
      contactList: `${CHAT_STORE_KEY}/contactList`,
      checkedFavourite: `${FAVOURITE_STORE_KEY}/checkedFavourite`
    }),
    currentDate() {
      const currentDate = new Date();
      const month = `0${currentDate.getMonth() + 1}`;
      return `${currentDate.getFullYear()}/${
        month.length === 2
          ? month
          : `${month.split("")[1]}${month.split("")[2]}`
      }/${currentDate.getDate()}`;
    },
    profileType() {
      return Athlete.userType();
    },
    profileId() {
      return Athlete.profileId();
    },
    userType() {
      return Athlete.userType();
    }
  },
  methods: {
    changeRoute(params) {
      if (this.$route.params.id) {
        this.$router.push(
          `/${this.profileId}/athelete/${this.$route.params.id}/${params}`
        );
      } else {
        this.$router.push(`/${this.profileId}/athelete/${params}`);
      }
    },
    changeListingRoute(params) {
      if (this.$route.params.id) {
        this.$router.push(
          `/${this.profileId}/athelete/${this.$route.params.id}/listing/${params}`
        );
      } else {
        this.$router.push(`/${this.profileId}/athelete/listing/${params}`);
      }
    },
    async dispatcher() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
        id: this.id,
        profileId: this.$route.params.profileId
      });
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthleteVideos`, {
        athleteId: this.id,
        limit: 3,
        page: 1
      });
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/checkFavourite`, {
        id: this.id
      });
    },
    getAthleteAge(date) {
      return moment() && moment().diff(moment(new Date(date)), "years");
    },
    connectPlayer() {
      const receiverInfo = btoa(
        JSON.stringify({
          receiver_id: this.id,
          receiver_type: "AthleteProfile"
        })
      );
      this.$router.push({
        path: `/${Athlete.profileId()}/chat/${receiverInfo}`
      });
    },
    async changeFav() {
      if (this.checkedFavourite.isFav) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: Athlete.profileId(),
          favTo: this.id
        });
        this.$store.dispatch(`${FAVOURITE_STORE_KEY}/unsetCheckedFavourite`);
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: Athlete.profileId(),
        favTo: this.id,
        typeFav: "athlete"
      });
      this.$store.dispatch(`${FAVOURITE_STORE_KEY}/setCheckedFavourite`);
    }
  },
  watch: {
    athlete(newVal, _) {
      this.atheleteData = new Athlete(newVal);
    }
  }
};
</script>

<style lang="scss">
.ml3 {
  font-weight: 900;
  font-size: 3.5em;
}
a {
  color: #000;
}
a:hover {
  color: #cc2f2a;
}
</style>
